import React from "react";
import {useTranslate} from "../../system/useTranslate";
import RibbonGroup from "./ribbon-group";
import {RIBBON_GROUPS} from "./ribbon-config";

function RibbonBar({onCommand, active}) {
    const translate = useTranslate();

    return (
        <div className="surface-50 border-bottom-1 border-300 w-full">
            <div className="flex align-items-center justify-content-between px-2 py-1 border-bottom-1 border-200">
                <span className="text-xs font-bold text-gray-600">{translate("toolbar-title")}</span>
            </div>
            <div className="flex align-items-stretch overflow-x-auto p-1 gap-1">
                {RIBBON_GROUPS.map((group) => (
                    <RibbonGroup key={group.id} group={group} onCommand={onCommand} active={active}/>
                ))}
            </div>
        </div>
    );
}

export default RibbonBar;